import { Button, Card, Dialog, Select, TextField } from '@material-ui/core'
import React, { useEffect, useState } from 'react'

const TYPES = ["Gift Match", "Gift All", "Game Match", "Game All", "Room Game Match", "Gift Room Match"]
export default function Leaderboard({ api }) {
    const [leaderboards, setLeaderboards] = React.useState([])
    const [change, setChange] = React.useState(false)
    const [showDialog, setShowDialog] = React.useState(false)
    const [name, setName] = useState('')
    const [value, setValue] = useState('')
    const [type, setType] = useState(0)
    useEffect(() => {
        api.axios.get("/leaderboard")
            .then(d => setLeaderboards(d))
            .catch(e => api.showSnack(e.error || 'Something went wrong', 'error'))
    }, [change])
    return (
        <div style={{ marginTop: 80 }}>
            <Dialog open={showDialog} fullScreen={true}>
                <Button onClick={e => setShowDialog(false)} variant="outlined" >Close</Button>
                <br /><br />
                <form onSubmit={e => {
                    e.preventDefault();
                    api.axios.post("/leaderboard/add", { name, type, value })
                        .then(d => {
                            api.showSnack('Added', 'success')
                            setShowDialog(false)
                            setChange(true)
                        })
                        .catch(e => api.showSnack(e.error || 'Something went wrong', 'error'))
                }}>
                    <TextField value={name} onChange={e => setName(e.target.value)} required fullWidth placeholder="Enter Leaderboard Name" />
                    <br /><br />
                    <TextField value={value} onChange={e => setValue(e.target.value)} required fullWidth placeholder="Enter Leaderboard Value" />
                    <br /><br />
                    <select required value={type} onChange={e => setType(e.target.value)} >
                        {TYPES.map((s, i) => <option value={i}>{s}</option>)}
                    </select>
                    <br /><br />
                    <button variant="contained">Submit</button>
                </form>
            </Dialog>
            <Button onClick={e => setShowDialog(true)} variant="outlined" >Add Leaderboard</Button>
            <br /><br />
            {leaderboards.map(s =>
                <Card style={{ margin: 7, display: 'flex', alignItems: 'center', padding: 10 }}>
                    <div style={{ marginLeft: 10, marginRight: 5 }}>
                        <div>Id :  {s._id}</div>
                        <br />
                        <div >Name :  {s.name}</div>
                    </div>
                    <div style={{ flex: 1, marginLeft: 20 }}>
                        <div>Disabled: {s.disabled ? 'yes' : 'no'}</div>
                        <br />
                        <div >Type : {TYPES[s.type]}</div>
                        <br/>
                        <div >Value : {s.value}</div>
                    </div>
                    <Button onClick={e => {
                        if (window.confirm('Confirm')) {
                            api.axios.get("/leaderboard/disable/" + s._id)
                                .then(d => {
                                    api.showSnack('Leaderboard ' + s.type ? 'Disabled' : 'Enabled' + ' successfully', 'success')
                                    setShowDialog(false)
                                    setChange(!change)
                                })
                                .catch(e => api.showSnack(e.error || 'Something went wrong', 'error'))

                        }
                    }} variant="outlined">Disable/Enable</Button>
                    <Button onClick={e => {
                        if (window.confirm('Confirm')) {
                            api.axios.get("/leaderboard/delete/" + s._id)
                                .then(d => {
                                    api.showSnack('Leaderboard deleted successfully', 'success')
                                    setChange(!change)
                                    setShowDialog(false)
                                })
                                .catch(e => api.showSnack(e.error || 'Something went wrong', 'error'))
                        }
                    }} variant="outlined">Delete</Button>
                </Card>)}
        </div>
    )
}
